<div class="vf-vh">

  <div class="vf-vh__head"
       role="button"
       tabindex="0"
       [attr.aria-expanded]="expanded"
       (click)="toggle()"
       (keydown.enter)="toggle()"
       (keydown.space)="$event.preventDefault(); toggle()">
    <mat-icon class="material-icons-outlined vf-vh__icon">bookmarks</mat-icon>
    <span class="vf-vh__title">Watched Vessels</span>
    <span class="vf-vh__count">{{ rows.length }}</span>
    <span class="vf-vh__spacer"></span>
    <mat-icon class="vf-vh__caret">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
  </div>

  <ng-container *ngIf="expanded">

    <div class="vf-vh__none" *ngIf="!rows.length">
      <mat-icon class="material-icons-outlined">bookmarks</mat-icon>
      <div>
        <div class="vf-vh__none-title">No watched vessels yet</div>
        <div class="vf-vh__none-note">
          Use the search box on the map, or the watch button on any
          vessel's popup. Every vessel you locate is kept here (the newest 50),
          where you can put it back on the map or refresh its latest position
          and details.
        </div>
      </div>
    </div>

    <div class="vf-vh__list" *ngIf="rows.length" role="listbox" aria-label="Watched Vessels">
      <div class="vf-vh__row"
           *ngFor="let row of rows; trackBy: trackByKey"
           role="option"
           tabindex="0"
           [class.is-onmap]="!row.stale && isOnMap(row)"
           [attr.aria-selected]="!row.stale && isOnMap(row)"
           (click)="pick(row)"
           (keydown.enter)="pick(row)"
           (keydown.space)="$event.preventDefault(); pick(row)">

        <span class="vf-vh__diamond" [class.is-stale]="row.stale"></span>

        <span class="vf-vh__text">
          <span class="vf-vh__name" [class.is-unnamed]="!row.isNamed">{{ row.label }}</span>
          <small>
            <ng-container *ngIf="row.isNamed">{{ row.mmsi ? 'MMSI ' + row.mmsi : 'IMO ' + row.imo }} · </ng-container>
            <ng-container *ngIf="row.ago">last position · {{ row.ago }}</ng-container>
            <ng-container *ngIf="!row.ago">no position stored</ng-container>
            <span class="vf-vh__dest" *ngIf="row.destination"> · → {{ row.destination }}</span>
          </small>
        </span>

        <span class="vf-vh__onmap" *ngIf="!row.stale && isOnMap(row)">ON MAP</span>

        <span class="vf-vh__acts">
          <button type="button" class="vf-vh__act is-primary"
                  [disabled]="!canLocate(row)"
                  [matTooltip]="!canLocate(row)
                    ? 'No valid position stored — use Refresh to fetch latest details'
                    : isOnMap(row) ? 'Center the map on this vessel' : 'Put this vessel on the map'"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="locateRow(row, $event)">
            <mat-icon class="material-icons-outlined">my_location</mat-icon>
          </button>
          <button type="button" class="vf-vh__act"
                  [disabled]="!!loadingKey || !!blocker"
                  [matTooltip]="blocker
                    || 'Get the latest position and vessel details · ' + refreshCost + (refreshCost === 1 ? ' credit' : ' credits')"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="refreshRow(row, $event)">
            <mat-icon class="material-icons-outlined"
                      [class.vf-vh__spin]="isLoading(row)">autorenew</mat-icon>
          </button>
          <button type="button" class="vf-vh__act"
                  *ngIf="!row.stale && isOnMap(row)"
                  matTooltip="Take off the map — stays in Watched Vessels"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="takeOffMapRow(row, $event)">
            <mat-icon class="material-icons-outlined">layers_clear</mat-icon>
          </button>
          <button type="button" class="vf-vh__act is-danger"
                  matTooltip="Remove from Watched Vessels — permanent"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="removeRow(row, $event)">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
        </span>
      </div>
    </div>

  </ng-container>

</div>
